<app-button variant="outlined" severity="contrast" [icon]="SVG.SHARE" [iconSource]="'svg'" [size]="'default'" pTooltip="Share" tooltipPosition="bottom" (clicked)="openShareDialog()" />

<app-dialog [visible]="shareDialog" (closed)="onCloseShareDialog()" title="Share this document"
    class="max-w-[45rem]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <app-share-to-users [contract]="contract" [shareDetails]="shareDetails" [projectId]="projectId"
            (addUserToShare)="addUserToShare($event)" (removeUserFromShare)="removeUserFromShare($event)"
            (updateSharedUser)="updateSharedUser($event)"
            (changeSharedWithWorkspace)="changeSharedWithWorkspace($event)"
            (changeSharedWithProject)="changeSharedWithProject($event)"
            (changeAnyoneAccess)="changeAnyoneAccess($event)"
            (refreshShareDetails)="refreshShareDetails()"></app-share-to-users>
    </ng-template>
</app-dialog>
